<script setup lang="ts">
import { partners } from '~/data/partners';
</script>

<template>
    <SectionsBase class="background">
        <div class="container">
            <ChipsDivider>شرکای تجاری</ChipsDivider>
            <h2>شرکای تجاری نواتل</h2>
            <div class="w-full mt-6 lg:mt-8 flex flex-col lg:flex-row gap-4 items-center justify-center">
                <div
                    v-for="partner, index in partners"
                    :key="partner.name"
                    class="w-full max-w-75 aspect-square p-1.5 rounded-3xl bg-linear-to-b from-white to-gray-100
                        shadow-gray-xss"
                    data-aos="flip-right" 
                    data-aos-duration="1000"
                    :data-aos-delay="index * 200"
                >
                    <div class="box" :style="`--i:${ index * 90 }deg;`">
                        <div class="w-full h-full py-4 px-1 rounded-[20px] bg-white flex-center flex-col gap-4 relative z-1">
                            <NuxtImg
                                width="100"
                                height="100"
                                :src="partner.img"
                                :alt="partner.name"
                                class="w-25 h-25"
                                loading="lazy"
                            />
                            <span class="h4 text-center">{{ partner.name }}</span>
                            <p class="text-center text-body2-semibold text-gray-400">{{ partner.desc }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    bg-[url('/svg/new/backgrounds/mesh-07-mobile.svg')] lg:bg-[url('/svg/new/backgrounds/mesh-07.svg')] 
    bg-center bg-size-[100%_auto] bg-no-repeat
}

@property --angle {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
}
.box {
    @apply
    w-full h-full p-px relative rounded-[22px] overflow-hidden
}
.box::before {
    animation: rotation 30s linear infinite;
    @apply
    content-[''] absolute top-0 left-0 w-full h-full
}
.box:nth-child(n)::before {
    background: conic-gradient(from calc(var(--angle) + var(--i)), transparent 60%, var(--color-warning-700));
}
@keyframes rotation {
    from { --angle: 0deg; }
    to { --angle: 360deg; }
}
</style>